<template>

  <section class="hero-area">
      <div class="container">
          <div class="row">

            <div class="hero-image-container col-12 col-sm-12 col-md-5 col-lg-5 col-xl-6 text-center">
                <img class='static-proto' src="static/proto.svg" alt="">
            </div>

            <div class="hero-tile-container col-12 col-sm-12 col-md-7 col-lg-7 col-xl-6">
                <h3 class="hero-splash gradient-special-color">{{ title }}<br /></h3>
<!--                 <p class="hero-legend">{{ legend }}</p> -->
                <a class="btn btn-main" href="mailto:hey@hackdagio.xyz" role="button">
                  <svg class="send-email-att btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 320"><circle cx="416" cy="64" r="64"/><path d="M209 64H17.8C6.7 64 3.9 67 6.5 74.5 8 78.9 14.9 82.6 19 84.7c11 5.8 163.8 89.1 169.5 92.1 5.7 3 11.5 4.4 20.5 4.4s14.8-1.4 20.5-4.4c3.8-2 72.6-39.5 121.6-66.1C341.6 97.6 336 81.4 336 64H209z"/><path d="M277.2 177.3l82.2 92.5c2 2 2.9 4.4 1.8 5.6-1.2 1.1-3.8.5-5.9-1.4l-98.6-83.2c-14.9 9.6-25.4 16.2-27.2 17.2-7.7 3.9-13.1 4.4-20.5 4.4s-12.8-.5-20.5-4.4c-1.9-1-12.3-7.6-27.2-17.2L62.7 274c-2 2-4.7 2.6-5.9 1.4-1.2-1.1-.3-3.6 1.7-5.6l82.1-92.5C91.9 145.8 17.5 93.4 9.3 89.2.5 84.7 0 90 0 94.1v205c0 9.3 13.7 20.9 23.5 20.9h371c9.8 0 21.5-11.7 21.5-20.9V144c-21.7 0-41.4-8.7-55.8-22.7-26 17.9-57.8 39.7-83 56z"/><path d="M417.7 10.7c12.1 0 23.3 4 32.3 10.6-18.4 23.9-61 43.8-81.2 67.9-3.6-7.3-5.6-15.4-5.6-24 0-30 24.5-54.5 54.5-54.5z" /></svg>
                Let's talk</a>

            </div>
          </div>
      </div>
  </section>

</template>

<script>
export default {
  name: 'Hero',
  data () {
    return {
      title: 'Delightful, consumer-grade experiences',
      from: 'desde Colchagua',
      legend: 'Brew es un colectivo de profesionales tecnólogos, consultores, diseñadores y desarrolladores de software, dedicados al servicio de consultoría en tecnologías de la información y desarrollo.'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hero-area {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 100px;
}
@media all and (max-width: 768px) {
  .hero-area {
    padding-top: 80px;
  }
}
.hero-image-container,
.hero-tile-container {
  height: 620px;
}
@media all and (max-width: 1199px) {
  .hero-image-container,
  .hero-tile-container {
    height: 620px;
  }
}
@media all and (max-width: 991px) {
  .hero-image-container,
  .hero-tile-container {
    height: 600px;
  }
}
@media all and (max-width: 768px) {
  .hero-image-container,
  .hero-tile-container {
    height: auto;
  }
}
@media all and (min-width: 769px) {
  .hero-image-container,
  .hero-tile-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
}

  .hero-splash {
    font-family: 'ClanOT-ExtdBook';
    font-weight: normal;
    line-height: 1.3;
    text-transform: lowercase;
}
@media (max-width: 1199px) {
  .hero-splash {
    font-size: 3em!important;
    }
}
@media (max-width: 991px) {
  .hero-splash {
    font-size: 2.6em!important;
    }
}
@media (max-width: 768px) {
  .hero-splash {
    font-size: 1.8em!important;
    }
  }

@media all and (min-width: 1200px) {
  .hero-splash {
    font-size: 4em!important;
  }
}

  .hero-splash small {
    font-size: 50%;
  }
  .hero-area .btn-main {
    margin-top: 30px; }

  .hero-splash .smaller {
    margin-top:24px;
  }

@media all and (max-width: 768px) {
  .hero-area {
    text-align: center;
  }

  .hero-image-container {
    margin-top:24px;
  }
  .hero-splash {
    margin-top: 48px;
    margin-bottom: 24px;
  }
  .hero-splash .smaller {
    margin-top: 6px;
  }
}

/* .hero-area  */
.navigation {
  background-color: transparent;
  -webkit-transition: all 0.3s ease-in-out 0s;
  -moz-transition: all 0.3s ease-in-out 0s;
  -ms-transition: all 0.3s ease-in-out 0s;
  -o-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
  padding: 10px 50px;
  margin: 0;
  border: 0; }
  .navigation .navbar-brand {
    display: inline-block; }
  .navigation .navbar-toggler {
    background: #fff;
    outline: none;
    border-radius: 0;
    float: right; }
    .navigation .navbar-toggler i {
      font-size: 22px; }

.logo {
  display: inline-block; }
  .logo h1 {
    color: #444;
    font-size: 25px;
    margin: 0;
    line-height: 1; }

.menu {
  margin-top: 14px; }
  .menu li {
    display: inline-block;
    margin: 0 10px; }
    .menu li a {
      color: #444;
      font-size: 14px;
      font-weight: bold; }
      .menu li a:hover, .menu li a:focus {
        background: none; }

.hero-splash, .hero-legend
{ color: #f8f9fb }

.static-proto {
    height: 600px;
    transform:rotate(-15deg);
    transition: all 250ms ease-in-out;
}
@media all and (max-width: 1199px) { .static-proto { height: 600px;
transform:rotate(-15deg); } }
@media all and (max-width: 991px) { .static-proto { height: 450px;
transform:rotate(-7.5deg); } }
@media all and (max-width: 768px) { .static-proto {
  height: inherit;
  width: 30%;
  transform:rotate(-90deg);
  margin: -60px 0 -60px 0;
   } }

.send-email-att {
  height: 1em;
  fill:#f39005;
  margin-right: 1em;
}

.gradient-special-color {
    background-image: linear-gradient(90deg,#ff8a00,#C87A00);
    -webkit-background-clip: text;
    -webkit-text-fill-color: #0000;
    display: inline-block;
}


</style>



// WEBPACK FOOTER //
// src/components/Hero.vue